import { AccredibleCredentialAppearanceComponentModule } from '@accredible-frontend-v2/components/credential-appearance';
import {
  AccredibleCarouselItemComponent,
  AccredibleCarouselMultiComponent,
} from '@accredible-frontend-v2/new-components/carousel';
import { AccredibleTileComponentModule } from '@accredible-frontend-v2/new-components/tile';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FavoriteComponentModule } from '../../../shared/components/favorite/favorite.component.module';
import { FeaturedModule } from '../../../shared/components/featured/featured.module';
import { ShareComponentModule } from '../../../shared/components/share/share.component.module';
import { TrendingCoursesComponent } from './trending-courses.component';

@NgModule({
  declarations: [TrendingCoursesComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    FavoriteComponentModule,
    ShareComponentModule,
    FeaturedModule,
    AccredibleCarouselMultiComponent,
    AccredibleCarouselItemComponent,
    AccredibleCredentialAppearanceComponentModule,
    AccredibleTileComponentModule,
  ],
  exports: [TrendingCoursesComponent],
})
export class TrendingCoursesModule {}
